import { Link } from 'react-router-dom';
import { ModuleLanding, ModuleOffers, Faq, SectionHead } from '../../shared/components/Common';
import Icon from '../../shared/components/Icons';
import { addDaysIso, formatPrice, img, placeOf } from '../../shared/data/common';
import { airlines, popularRoutes } from './data';
import { AirlineLogo } from './FlightSummary';

const perks = [
  ['zap', 'Instant e-ticket', 'Get your ticket on email & WhatsApp within seconds'],
  ['wallet', 'Zero convenience fee on UPI', 'Pay via UPI and save on every booking'],
  ['calendar', 'Free date change*', 'On Flexi & Super Flexi fares'],
  ['headset', '24x7 flight support', 'Rescheduling, cancellations & refunds'],
];

const faqs = [
  ['How do I get the cheapest flight tickets?', 'Book 3–6 weeks in advance, compare nearby dates using our fare calendar and apply the FLYFRESH coupon at checkout.'],
  ['Can I cancel or reschedule my flight?', 'Yes. Go to My Trips → Flights, open your booking and choose Cancel. Charges depend on the airline and the fare type you selected.'],
  ['When will I receive my refund?', 'Refunds are processed to the original payment method within 5–7 working days after the airline approves the cancellation.'],
  ['What documents do I need at the airport?', 'A valid government photo ID for domestic flights. For international flights, a passport valid for at least 6 months and a visa if required.'],
];

export default function FlightSearch() {
  const date = addDaysIso(7);
  return (
    <ModuleLanding tab="flights" title="Book domestic & international flights" subtitle="Lowest fares on 500+ airlines · Free cancellation options · Instant confirmation" image={img('1436491865332-7a61a109cc05', 1800)}>
      <section className="section container">
        <div className="perk-row">
          {perks.map(([ic, t, d]) => (
            <div key={t} className="perk"><span className="perk-icon"><Icon name={ic} size={22} /></span><div><b>{t}</b><span className="muted small">{d}</span></div></div>
          ))}
        </div>
      </section>

      <section className="section container">
        <SectionHead title="Flight offers" sub="Apply at checkout to save more" />
        <ModuleOffers module="flights" />
      </section>

      <section className="section container">
        <SectionHead title="Popular flight routes" sub="Lowest fares found in the last 24 hours" />
        <div className="route-grid">
          {popularRoutes.map(([from, to, price]) => (
            <Link key={from + to} to={`/flights/results?from=${from}&to=${to}&date=${date}&adults=1&travellers=1&cabin=Economy`} className="route-card">
              <span className="route-icon"><Icon name="flights" size={20} /></span>
              <div className="route-info">
                <b>{from} <Icon name="arrow" size={12} /> {to}</b>
                <span className="muted small">{placeOf(from).code} – {placeOf(to).code}</span>
              </div>
              <div className="route-price"><span className="muted small">from</span><b>{formatPrice(price)}</b></div>
            </Link>
          ))}
        </div>
      </section>

      <section className="section container">
        <SectionHead title="Fly with top airlines" />
        <div className="airline-strip">
          {airlines.map((a) => (
            <div key={a.code} className="airline-chip"><AirlineLogo airline={a} size={34} /><b>{a.name}</b></div>
          ))}
        </div>
      </section>

      <section className="section container">
        <SectionHead title="Frequently asked questions" />
        <Faq items={faqs} />
      </section>
    </ModuleLanding>
  );
}
